import styles from "./styles.module.scss";
import { ReactComponent as UserImage } from "../../assets/images/svg/users.svg";
import { ReactComponent as UserCorrect } from "../../assets/images/svg/user-correct.svg";
import { ReactComponent as UserRemove } from "../../assets/images/svg/user-remove.svg";

import ClientsStats from "../../components/homeStats/clientsStats";
import useGetUserStats from "../../hooks/useGetUserStats";
import classNames from "classnames";
import useGetContractStats from "../../hooks/useGetContractStats";
import ContractStats from "../../components/homeStats/contractStats";
import Loading from "../../components/common/loading";
import {
  CONTRACTSITEMS,
  CONTRACT_STATS,
  MAP_STATE_TEXT,
  ORG_MAP_STATE_TEXT,
} from "../../enums";
import { USERS_STATS } from "./constant";
import { useCallback, useEffect, useState } from "react";
import { getAccessTokenSync } from "../../setup/auth/oidc";
import { getOrganization } from "../../setup/api/services/organization";
import OrganizationInfo from "../../components/homeStats/organizationInfo";
import { useOrganizationCode } from "../../setup/util/extractOrganizationCode";

const Stats = () => {
  const userToken = getAccessTokenSync();
  const [organization, setOrganization] = useState<{ name?: string } | null>(
    null
  );

  const organizationCode = useOrganizationCode(userToken) || undefined;

  const fetchOrganization = useCallback(async () => {
    if (!organizationCode) return;
    const response = await getOrganization(organizationCode as string);
    setOrganization(response.data);
  }, [organizationCode]);

  useEffect(() => {
    if (organizationCode) {
      fetchOrganization();
    }
  }, [fetchOrganization, organizationCode]);

  const { loading: usersStatsLoading, data: usersStats } =
    useGetUserStats(organizationCode);
  const { loading: contractStatsLoading, data: contractStats } =
    useGetContractStats(undefined, organizationCode);

  if (usersStatsLoading || contractStatsLoading) return <Loading />;

  return (
    <div className={styles.page_layout}>
      {organization && <OrganizationInfo organization={organization} />}
      <div className={organization ? styles.stats_container : undefined}>
        <div>
          <p className={styles.title}>
            {organization
              ? USERS_STATS.CLIENT_ADMIN_HEADING.replace(
                  "{{val, string}}",
                  organization?.name || ""
                )
              : USERS_STATS.HEADING}
          </p>
          <div className={styles.usersStats}>
            <ClientsStats
              icon={<UserImage />}
              title={USERS_STATS.TOTAL_USER}
              count={usersStats?.totalUsersCount || 0}
            />
            {!organization && (
              <>
                <ClientsStats
                  icon={<UserCorrect />}
                  title={USERS_STATS.ACTIVE_USER}
                  count={usersStats?.activeUsersCount || 0}
                />
                <ClientsStats
                  icon={<UserRemove />}
                  title={USERS_STATS.INACTIVE_USER}
                  count={usersStats?.inActiveUsersCount || 0}
                />
              </>
            )}
          </div>
        </div>

        <div>
          <p className={classNames(styles.title)}>{CONTRACT_STATS.HEADING}</p>
          <div className={styles.contractStats}>
            {!organization ? (
              CONTRACTSITEMS?.map((item) => (
                <ContractStats
                  key={item.key}
                  title={CONTRACT_STATS[item.key]}
                  item={item}
                  values={contractStats}
                  MAP_STATE_TEXT={MAP_STATE_TEXT}
                />
              ))
            ) : (
              <ContractStats
                key={"CLIENT_ADMIN_CONTRACT"}
                title={CONTRACT_STATS["CLIENT_ADMIN_CONTRACT"]}
                item={CONTRACTSITEMS[0]}
                values={contractStats}
                MAP_STATE_TEXT={ORG_MAP_STATE_TEXT}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stats;
